module.exports = __webpack_public_path__ + "static/media/after-effects.241dc01a.svg";